import React, { PureComponent } from "react";

export default class CO extends PureComponent {
  render() {
    return (
      <svg
        xmlns="http://www.w3.org/2000/svg"
        height="13"
        viewBox="0 0 512 341.326"
      >
        <g transform="translate(0 -85.337)">
          <rect
            width="512"
            height="341.326"
            transform="translate(0 85.337)"
            fill="#ffda44"
          />
          <rect
            width="512"
            height="83.567"
            transform="translate(0 343.096)"
            fill="#d80027"
          />
          <rect
            width="512"
            height="87.096"
            transform="translate(0 256)"
            fill="#0052b4"
          />
        </g>
      </svg>
    );
  }
}
